/**
 * Nonrefundable per-class deposit – co-op-wide amount stored in site settings (cents).
 * Secures a child's spot after enrollment; paid directly to the tutor.
 */

export const DEFAULT_CLASS_DEPOSIT_CENTS = 2000; // $20.00

export const MIN_CLASS_DEPOSIT_CENTS = 0;
export const MAX_CLASS_DEPOSIT_CENTS = 500_00; // $500.00

export function normalizeClassDepositCents(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) {
    return DEFAULT_CLASS_DEPOSIT_CENTS;
  }
  const rounded = Math.round(n);
  if (rounded < MIN_CLASS_DEPOSIT_CENTS) {
    return MIN_CLASS_DEPOSIT_CENTS;
  }
  if (rounded > MAX_CLASS_DEPOSIT_CENTS) {
    return MAX_CLASS_DEPOSIT_CENTS;
  }
  return rounded;
}

/** USD display for whole-dollar amounts (e.g. 2000 → "$20"). */
export function formatClassDepositUsd(cents: number): string {
  const normalized = normalizeClassDepositCents(cents);
  const dollars = normalized / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: dollars % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(dollars);
}
